import { isDisabled } from 'app/infrastructure/data/date';
import { SavedReport } from '../types-store';

export const getPrevElement = (
  savedReports: SavedReport[],
  index: number,
  displayDisabled: boolean
) => savedReports
  ?.slice(0, index)
  ?.reverse()
  ?.find(report => displayDisabled || !isDisabled(report?.disabled));

export const getNextElement = (
  savedReports: SavedReport[],
  index: number,
  displayDisabled: boolean
) => savedReports
  ?.slice(index + 1)
  ?.find(report => displayDisabled || !isDisabled(report?.disabled));
